export const main = {
    hisTimeTable: "<name>{{name}}</name><space/><normal>님의 시간표</normal>",
    schedule: {
        title: "{{content}}까지",
        link: "학사 시스템 바로가기",
        contents: {
            beginning: "개강",
            end: "종강",
            courseRegistrationPeriodStart: "수강신청기간 시작",
            courseRegistrationPeriodEnd: "수강신청기간 종료",
            courseAddDropPeriodEnd: "수강변경기간 종료",
            courseDropDeadline: "수강취소 마감",
            courseEvaluationDeadline: "강의평가 마감",
            gradePosting: "성적게시",
        },
    },
    reviewSection: {
        title: "{{lectureName}} 강의는 어땠나요?",
        placeholder: "학점, 로드 등의 평가에 대해 설명해주세요.",
        writeAnother: "다른 과목 후기 쓰기",
    },
    recentFeed: {
        title: "<bold>따끈따끈</bold><space/><normal>과목후기</normal>",
    },
    likedMajorFeed: {
        title: "<bold>사랑받는</bold><space/><normal>과목후기</normal>",
    },
    hallOfFameFeed: {
        title: "<bold>명예의</bold><space/><normal>전당</normal>",
    },
    scheduleFeed: {
        title: "주요 일정",
        noSchedules: "일정 없음",
    },
}
